// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ActionLink from '../../../shared/components/action-link';
import CalculationPanel from './calculation-panel';
import ClaimDetails from './claim-details-section';
import ClaimLineItemPanel from './claim-line-item-panel';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import CustomerPanel from '../../../shared/components/customer-panel/customer-panel';
import FailurePanel from './failure-panel';
import FileAttachmentPanel from '../../../shared/components/file-attachment-panel';
import LabeledNode from '../../../shared/components/labeled-node';
import LabeledString from '../../../shared/components/labeled-string';
import LaborsPanel from './labors-panel';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import OtherCreditsPanel from './other-credits-panel';
import PartsPanel from '../../shared/components/parts-panel';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import ProductPanel from '../../shared/components/product-panel';
import SpaClaim from '@deere/cps-it.warranty-model-factory/lib/claim-special-allowance';
import {UPTIME_ASSURANCE} from '../constants';
import ValueOfRepairPanel from './value-of-repair';
import {buildDate} from '../../../shared/services/build-date';
import {getTempAttachmentServiceConfig} from '../../shared/services/claim-shared-helper';
import {handleWarrantyLink} from '../../../claim/shared/services/warranty-modal-actions';
import {translate} from '../../../shared/services/translation-service';

function handleFileDelete(file) {

    this.actions.deleteFile(file);

}

function handleFileUploadSuccess(file, dropzone) {

    const fileObject = JSON.parse(file.xhr.response);

    this.actions.addFile(fileObject);
    dropzone.removeFile(file);

}

function openCreateClaimModal() {

    this.actions.updateCreateClaimModalVisibility(true);
    this.actions.updateClaimModalMode('EDIT');

}

const FullDetails = props =>
    <div className='spa-claim-details'>
        <main>
            <div className='create-claim-details'>
                <LabeledNode
                    className='claim-type'
                    data={
                        props.claim.claimNumber ?
                            <span>{props.claim.claimType.value}</span> :
                            <ActionLink
                                isDisabled={false}
                                label={translate('SPECIAL_ALLOWANCE')}
                                onClick={props::openCreateClaimModal}
                                type='button-link'
                            />
                    }
                    label='CLAIM_TYPE'
                />
                <LabeledString
                    className='claim-status'
                    data={props.claim.claimStatus.value}
                    label='STATUS'
                />
                <LabeledString
                    className='created-date'
                    data={buildDate(props.claim.recordInfo.createdDate)}
                    label='CREATED'
                />
                <LabeledString
                    className='modified-date'
                    data={buildDate(props.claim.recordInfo.updatedDate)}
                    label='MODIFIED'
                />
            </div>
            <ClaimDetails/>
            <FailurePanel/>
            {!props.claim.showValidate &&
                <div className='claim-items'>
                    {props.tcsm &&
                        <ClaimLineItemPanel
                            claimNumber={props.claim.claimNumber}
                            tabm={props.tabm}
                        />
                    }
                    {props.claim.specialAllowanceType.key !== UPTIME_ASSURANCE &&
                        <PartsPanel
                            actions={props.actions}
                            errors={props.claim.errors}
                            isEditable={props.isEditable}
                            parts={props.claim.parts}
                            partsGroupedByPartNumber={props.partsGroupedByPartNumber}
                            showPartInvoiceNumber={props.claim.rules.showPartInvoiceNumber}
                            typeClaim={props.claim.claimType.value}
                        />}
                    {props.claim.specialAllowanceType.key !== UPTIME_ASSURANCE && <LaborsPanel/>}
                    <OtherCreditsPanel/>
                    {!props.claim.hideClaimValueDetails &&
                        <div>
                            <ValueOfRepairPanel
                                listPricing={props.claim.valueOfRepairList}
                                netPricing={props.claim.valueOfRepairNet}
                            />
                            <CalculationPanel/>
                        </div>
                    }
                </div>
            }
        </main>
        <aside>
            <ProductPanel
                baseMachineCode={props.product.baseMachineCode}
                buildDate={props.product.buildDate}
                handleWarrantyLink={props::handleWarrantyLink}
                imageUrl={props.product.imageUrl}
                latestPerUnitMeasurements={props.latestPerUnitMeasurements}
                modelNumber={props.product.model}
                pin={props.product.pin}
                pipIndicator={props.product.pipIndicator}
                updatedDate={props.product.useAmountLastUpdated}
                useAmount={props.product.useAmount}
            />
            <CustomerPanel
                customer={props.customer}
                isCkcCustomerFailed={props.isCkcCustomerFailed}
                product={props.product}
            />
            <FileAttachmentPanel
                files={props.claim.file}
                isUploadAllowed={!props.tcsm}
                onFileDelete={props::handleFileDelete}
                onFileUploadSuccess={props::handleFileUploadSuccess}
                serviceConfig={getTempAttachmentServiceConfig(props.claim.claimNumber, props.temporaryObjectKey)}
            />
        </aside>
    </div>;

FullDetails.displayName = 'FullDetails';
FullDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    claim: PropTypes.instanceOf(SpaClaim).isRequired,
    claimNumber: PropTypes.string,
    claimType: PropTypes.object,
    customer: PropTypes.instanceOf(Customer).isRequired,
    isCkcCustomerFailed: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    latestPerUnitMeasurements: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    partsGroupedByPartNumber: PropTypes.object.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    tabm: PropTypes.bool.isRequired,
    tcsm: PropTypes.bool.isRequired,
    temporaryObjectKey: PropTypes.string
};

export default FullDetails;



// WEBPACK FOOTER //
// ./src/claim/spa/components/full-details.js